/**
 * Directive to prevent browser autofill on search inputs
 * Usage: <input v-no-autofill v-model="search" />
 */
export default {
  mounted(el) {
    // Clear on focus
    el.addEventListener('focus', () => {
      // Force Vue to detect the change
      setTimeout(() => {
        el.dispatchEvent(new Event('input', { bubbles: true }));
      }, 10);
    });

    // Clear on input
    el.addEventListener('input', (e) => {
      // This ensures the input value matches the v-model binding
      if (el._value && el.value !== el._value) {
        el.value = el._value;
      }
      if (e.inputType === 'insertFromPaste') {
        el.value = el._value;
      }
    });
  },
  updated(el, binding) {
    // Store the expected value from v-model
    el._value = binding.value;
    // Ensure input stays clean
    if (el.value && binding.value && el.value !== binding.value) {
      el.value = binding.value;
    }
  },
};